import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Summer/Fractions/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Fractions',
  field: 'Number',
  weeks: [4, 5],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/Fractions/1RecogniseAHalfOfAnObjectOrAShape" */ './1RecogniseAHalfOfAnObjectOrAShape'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/Fractions/2FindAHalfOfAnObjectOrAShape" */ './2FindAHalfOfAnObjectOrAShape'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/Fractions/3RecogniseAHalfOfAQuantity" */ './3RecogniseAHalfOfAQuantity'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/Fractions/4FindAHalfOfAQuantity" */ './4FindAHalfOfAQuantity'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/Fractions/5RecogniseAQuarterOfAnObjectOrAShape" */ './5RecogniseAQuarterOfAnObjectOrAShape'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/Fractions/6FindAQuarterOfAnObjectOrAShape" */ './6FindAQuarterOfAnObjectOrAShape'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/Fractions/7RecogniseAQuarterOfAQuantity" */ './7RecogniseAQuarterOfAQuantity'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/Fractions/8FindAQuarterOfAQuantity" */ './8FindAQuarterOfAQuantity'
        )
    })
  ]
});
export default Block;
